import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';
import { cn } from '../../utils/cn';
import { Panel, type PanelPadding } from './Panel';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
    padding?: PanelPadding;
    header?: ReactNode;
    footer?: ReactNode;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
    { padding = 'md', header, footer, className, children, ...rest },
    ref,
) {
    return (
        <Panel ref={ref} variant="solid" padding={padding} className={cn('flex flex-col gap-3', className)} {...rest}>
            {header && <div className="flex items-center justify-between gap-2">{header}</div>}
            {children}
            {footer && <div className="flex items-center justify-end gap-2">{footer}</div>}
        </Panel>
    );
});

export default Card;
